import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { startRegistration } from '@simplewebauthn/browser';
import { NGX_ECHARTS_CONFIG, NgxEchartsModule } from 'ngx-echarts';
import { AvatarModule } from 'primeng/avatar';
import { CardModule } from 'primeng/card';
import { DialogComponent } from '../../../../@core/components/ui/dialog/dialog.component';
import { HlmDialogHeaderComponent } from '../../../../@core/components/spartan/dialog/hlm-dialog-header.component';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { environment } from '../../../../../environments/environment.dev';
import { ButtonComponent } from '../../../../@core/components/ui/button/button.component';
import { SelectComponent, SelectOption, SelectConfig } from '../../../../@core/components/ui/select';
import { ToggleComponent } from '../../../../@core/components/ui/toggle/toggle.component';
import { DEACTIVATION_STATUS, IUser, SHARE_ACCESS } from '../../../../@core/models/model';
import { AuthenticationService, PRIMARY_AUTH_METHOD } from '../../../../@core/services/authentication.service';
import { ToastService } from '../../../../@core/services/toast.service';
import { PhoneInputComponent } from '../../../../@shared/components/phone-input/phone-input.component';
import { TableColumn, TableConfig } from '../../../../@shared/models/table.models';
import { FullNamePipe } from '../../../../@shared/pipes/fullName.pipe';
import { UserAvatarPipe } from '../../../../@shared/pipes/user-avatar-pipe';
import { ConsumptionService } from '../../../services/consumption.service';
import { RequestAccessService } from '../../../services/request-access.service';
import { UserService } from '../../../services/user.service';
import { OrganizationSetupFormService } from '../../../services/organization-setup-from.service';
import { GAUGE_COLORS, setGuageChart } from '../../../utils';
import { TransferOwnershipDialogComponent } from '../../../../@shared/components/transfer-ownership-dialog/transfer-ownership-dialog.component';
import { ADDITIONAL_ROLES, USER_ROLE } from 'src/app/@core/models/enums';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { TRANSFER_OWNERSHIP } from 'src/app/common/svgs';


@Component({
  selector: 'app-profile-settings',
  imports: [
    CardModule,
    AvatarModule,
    ButtonComponent,
    ReactiveFormsModule,
    PhoneInputComponent,
    SkeletonModule,
    TableModule,
    NgxEchartsModule,
    DialogComponent,
    HlmDialogHeaderComponent,
    InputTextModule,
    TextareaModule,
    SelectModule,
    FormsModule,
    CommonModule,
    FormsModule,
    PasswordModule,
    ToggleSwitchModule,
    TitleCasePipe,
    SelectComponent,
    TooltipModule,
    ToggleComponent,
    TransferOwnershipDialogComponent,
    IconComponent,
    UserAvatarPipe,
    FullNamePipe
  ],
  providers: [
    {
      provide: NGX_ECHARTS_CONFIG,
      useValue: {
        echarts: () => import('echarts')
      }
    }
  ],
  standalone: true,
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponentSettings implements OnInit {

  @ViewChild('pictureFileInput') pictureFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('mfaSelect') mfaSelect!: SelectComponent;
  @ViewChild('phoneInput') phoneInput!: PhoneInputComponent;
  profileForm!: FormGroup;
  currentUser!: IUser | null | undefined;
  selectedFile: File | null = null;
  initialProfilePicture: string | null = null;
  validImageTypes: string[] = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];

  canEdit: boolean = false;
  canDeactivate: boolean = false;
  canRevokeDeactivation: boolean = false;
  removePicture: boolean = false;
  private userAvatarPipe = new UserAvatarPipe();
  private fullNamePipe = new FullNamePipe();
  loading: boolean = false
  mfaEnabled: boolean = false;
  IsPassKeyEnabled: boolean = false
  IsAuthenticatorModeEnabled: boolean = false
  openMfaDialog: boolean = false

  consumptionData: {
    date: string,
    tokens: number,
    cost: number
  }[] = []

  changePasswordVisible: boolean = false
  changePasswordForm!: FormGroup
  consumptionDataLoading: boolean = false
  totalRecords: number = 0
  totalTokens: number = 0
  totalCost: number = 0
  complianceRate: number = 0
  chartOption: echarts.EChartsOption = {}
  consumptionColumns: TableColumn[] = []
  consumptionTableConfig: TableConfig = {}


  PRIMARY_AUTH_METHOD = PRIMARY_AUTH_METHOD;

  get mfaOptions(): SelectOption[] {
    return [
      {
        label: 'Passkeys',
        value: PRIMARY_AUTH_METHOD.PASSKEYS,
        disabled: this.currentUser?.passkey === undefined ||
          this.currentUser?.passkey === null ||
          this.currentUser?.passkey.success === false
      },
      { label: 'Email OTP', value: PRIMARY_AUTH_METHOD.EMAIL_OTP },
      // { label: 'SMS OTP', value: PRIMARY_AUTH_METHOD.SMS_OTP },
      {
        label: 'Authenticator App',
        value: PRIMARY_AUTH_METHOD.MFA,
        disabled: !this.currentUser?.mfaSecret || this.currentUser?.mfaSecret === ""
      }
    ];
  }

  mfaConfig: SelectConfig = {
    placeholder: 'Select MFA Method',
    searchable: false,
    clearable: false,
    disabled: false,
    styleClass: 'border border-gray-300',
    style: { 'width': '100%' },
    appendTo: 'body'
  };

  mfaConfigDisabled: SelectConfig = {
    placeholder: 'Select MFA Method',
    searchable: false,
    clearable: false,
    disabled: true,
    styleClass: 'border border-gray-300',
    style: { 'width': '100%' },
    appendTo: 'body'
  };

  selectedMfaMethod: PRIMARY_AUTH_METHOD = PRIMARY_AUTH_METHOD.EMAIL_OTP;

  qrCodeDataUrl: string = '';
  mfaCode: string = '';
  qrCodeLoading: boolean = false;
  verifyingOtp: boolean = false;

  deactivateDialogVisible: boolean = false;
  deactivateConfirmation: string = '';
  deactivateReason: string = '';
  deactivatingAccount: boolean = false;
  orgUserCount: number = 0;
  loadingOrgUserCount: boolean = false;
  deletingOrganization: boolean = false;
  SVG = TRANSFER_OWNERSHIP

  revokeDeactivationDialogVisible: boolean = false;
  revokingDeactivation: boolean = false;

  transferOwnershipDialogVisible: boolean = false;

  // Transfer billing admin dialog (shown before deactivation when user is a billing admin)
  transferBillingAdminDialogVisible: boolean = false;
  billingAdminTransferUsers: IUser[] = [];
  billingAdminTransferFilteredUsers: IUser[] = [];
  billingAdminTransferSearchQuery: string = '';
  selectedBillingAdminTransferUser: IUser | null = null;
  isTransferringBillingAdmin: boolean = false;

  /**
   * Check if default transfer should be disabled
   * Disable if current user is SUPER_ADMIN and is the account owner (can't transfer to themselves)
   */
  get isDefaultTransferDisabled(): boolean {
    if (!this.currentUser) {
      return false;
    }
    const isSuperAdmin = this.currentUser.role === USER_ROLE.SUPER_ADMIN;
    return isSuperAdmin;
  }

  get isSuperAdmin(): boolean {
    return this.currentUser?.role === USER_ROLE.SUPER_ADMIN;
  }

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private toast: ToastService,
    private authService: AuthenticationService,
    private router: Router,
    private consumptionService: ConsumptionService,
    private toastService: ToastService,
    private authenticationService: AuthenticationService,
    private requestAccessService: RequestAccessService,
    private organizationService: OrganizationSetupFormService
  ) {
    this.authService.currentUser.subscribe(res => {
      this.currentUser = res
      if (this.currentUser) {
        this.selectedMfaMethod = this.currentUser.primaryAuthMethod
      }
    });
  }

  ngOnInit() {
    this.profileForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: [''],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [{ countryCode: "1", contactNumber: '', countryShortName: 'US' }],
      profilePicture: [''],
      username: ['', [Validators.required]],
      selectedMfaMethod: [{ value: this.selectedMfaMethod, disabled: true }]
    });
    this.initializeChangePasswordForm();

    // Initialize consumption table configuration
    this.consumptionColumns = [
      { field: 'rowIndex', header: 'S. No.', type: 'text', width: '80px' },
      { field: 'date', header: 'Date', type: 'text' },
      { field: 'totalTokens', header: 'Token', type: 'text' }
    ];

    this.consumptionTableConfig = {
      paginator: false,
      loading: false,
      emptyMessage: 'No data available',
      rows: 10
    };

    this.getProfile();
    this.chartOption = setGuageChart(this.complianceRate, [GAUGE_COLORS.GREEN, GAUGE_COLORS.YELLOW, GAUGE_COLORS.RED])
  }

  getProfile() {
    this.loading = true
    this.userService.getCurrentUser().subscribe((res) => {
      this.currentUser = res.data;
      this.canDeactivate = res.data?.deactivationStatus == null;
      this.canRevokeDeactivation = res.data?.deactivationStatus == DEACTIVATION_STATUS.REQUESTED;
      this.mfaEnabled = this.currentUser?.mfaEnabled || false;
      this.initialProfilePicture = environment.s3Url + '/' + res.data!.profilePicture?.url;
      this.initializeForm();
      this.loading = false
    });
  }

  getTodaysConsumption() {
    this.consumptionService.getTodaysConsumption({ isOrganizationConsumption: false }).subscribe((res) => {
      if (res.success) {
        this.complianceRate = res.data.totalCost
        this.totalTokens = res.data.totalTokens
        this.totalCost = res.data.totalCost
        this.chartOption = setGuageChart(this.complianceRate, [GAUGE_COLORS.GREEN, GAUGE_COLORS.YELLOW, GAUGE_COLORS.RED], 20) // max value is $20 dollars for user
      }
    })
  }

  initializeForm() {
    this.profileForm.patchValue({
      firstName: this.currentUser?.firstName,
      lastName: this.currentUser?.lastName,
      email: this.currentUser?.email,
      phoneNumber: this.currentUser?.phoneNumber,
      profilePicture: this.userAvatarPipe.transform(this.currentUser),
      username: this.currentUser?.username,
      primaryAuthMethod: this.currentUser?.primaryAuthMethod,
    });

    this.selectedMfaMethod = this.currentUser?.primaryAuthMethod || PRIMARY_AUTH_METHOD.EMAIL_OTP;
  }

  enterEditMode() {
    this.canEdit = true;
  }

  deactivateAccount() {
    this.deactivateDialogVisible = true;
    this.deactivateConfirmation = '';
    this.deactivateReason = '';
    if (this.isSuperAdmin) {
      this.loadingOrgUserCount = true;
      this.userService.getAllActiveUsersAndInvitesCount().subscribe({
        next: (res) => {
          this.orgUserCount = res.data?.totalActiveUsers ?? 0;
          this.loadingOrgUserCount = false;
        },
        error: () => { this.loadingOrgUserCount = false; }
      });
    }
  }

  confirmDeleteOrganization() {
    this.deletingOrganization = true;
    this.organizationService.deleteOrganization().subscribe({
      next: (res: any) => {
        if (res.success) {
          this.toast.success('Organization deleted successfully');
          this.authService.logout();
        } else {
          this.toast.error(res.message || 'Failed to delete organization');
        }
        this.deletingOrganization = false;
        this.deactivateDialogVisible = false;
      },
      error: (err: any) => {
        this.toast.error(err?.error?.message || 'Failed to delete organization');
        this.deletingOrganization = false;
      }
    });
  }

  revokeDeactivation() {
    this.revokeDeactivationDialogVisible = true;
  }

  cancelRevokeDeactivation() {
    this.revokeDeactivationDialogVisible = false;
  }

  confirmRevokeDeactivation() {
    if (!this.currentUser?.email) {
      this.toast.error('User email not found');
      return;
    }

    this.revokingDeactivation = true;
    this.requestAccessService.revokeDeactivation(this.currentUser.email).subscribe({
      next: (res) => {
        if (res.success) {
          this.toast.success('Deactivation revoked successfully');
          this.revokeDeactivationDialogVisible = false;
          this.getProfile();
        } else {
          this.toast.error(res.message || 'Failed to revoke deactivation');
        }
        this.revokingDeactivation = false;
      },
      error: (err) => {
        this.toast.error(err?.message || 'Failed to revoke deactivation');
        this.revokingDeactivation = false;
      }
    });
  }

  cancelDeactivate() {
    this.deactivateDialogVisible = false;
    this.deactivateConfirmation = '';
    this.deactivateReason = '';
  }

  confirmDeactivate() {
    if (this.deactivateConfirmation?.toLowerCase() !== 'deactivate') {
      return;
    }

    if (!this.currentUser?.email) {
      this.toast.error('User email not found');
      return;
    }

    const isBillingAdmin = this.currentUser.additionalRoles?.includes(ADDITIONAL_ROLES.BILLING_ADMIN) ?? false;

    if (isBillingAdmin) {
      this.deactivateDialogVisible = false;
      this.openBillingAdminTransferDialog();
      return;
    }

    this.proceedWithDeactivation();
  }

  private proceedWithDeactivation() {
    if (!this.currentUser?.email) return;

    // Check if user is account owner (SUPER_ADMIN) - if so, show transfer ownership dialog
    const isOwner = this.currentUser.role === USER_ROLE.SUPER_ADMIN;

    if (isOwner) {
      this.deactivateDialogVisible = false;
      this.transferOwnershipDialogVisible = true;
    } else {
      this.deactivatingAccount = true;
      this.requestAccessService.requestForDeactivation(this.currentUser.email, this.deactivateReason || '').subscribe({
        next: (res) => {
          if (res.success) {
            this.toast.success('Request for deactivation submitted successfully');
            this.deactivateDialogVisible = false;
            this.deactivateConfirmation = '';
            this.deactivateReason = '';
            this.getProfile();
          } else {
            this.toast.error(res.message || 'Failed to submit deactivation request');
          }
          this.deactivatingAccount = false;
        },
        error: (err) => {
          this.toast.error(err?.message || 'Failed to submit deactivation request');
          this.deactivatingAccount = false;
        }
      });
    }
  }

  openBillingAdminTransferDialog() {
    this.selectedBillingAdminTransferUser = null;
    this.billingAdminTransferSearchQuery = '';
    this.userService.getUsers().subscribe(res => {
      this.billingAdminTransferUsers = (res.data?.users ?? []).filter((u: IUser) => u._id !== this.currentUser?._id);
      this.billingAdminTransferFilteredUsers = [...this.billingAdminTransferUsers];
      this.transferBillingAdminDialogVisible = true;
    });
  }

  onBillingAdminTransferSearch() {
    const query = this.billingAdminTransferSearchQuery.toLowerCase().trim();
    if (!query) {
      this.billingAdminTransferFilteredUsers = [...this.billingAdminTransferUsers];
      return;
    }
    this.billingAdminTransferFilteredUsers = this.billingAdminTransferUsers.filter(u => {
      const name = (u.fullName || `${u.firstName} ${u.lastName}`).toLowerCase();
      return name.includes(query) || u.email.toLowerCase().includes(query);
    });
  }

  confirmBillingAdminTransfer() {
    if (!this.selectedBillingAdminTransferUser) {
      this.toast.error('Please select a user to transfer billing admin to');
      return;
    }
    this.isTransferringBillingAdmin = true;
    this.userService.transferBillingAdmin(this.selectedBillingAdminTransferUser._id as string).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.toast.success('Billing admin transferred successfully');
          this.transferBillingAdminDialogVisible = false;
          this.proceedWithDeactivation();
        } else {
          this.toast.error(res.message || 'Transfer failed');
        }
        this.isTransferringBillingAdmin = false;
      },
      error: (err: any) => {
        this.toast.error(err?.error?.message || 'Transfer failed');
        this.isTransferringBillingAdmin = false;
      }
    });
  }

  cancelBillingAdminTransfer() {
    this.transferBillingAdminDialogVisible = false;
  }

  getTransferFunction() {
    return (transferEmail: string) => {
      if (!this.currentUser?._id) {
        this.toast.error('User ID not found');
        return new Observable(observer => {
          observer.error({ error: { message: 'User ID not found' } });
          observer.complete();
        });
      }

      // Use the new transfer-ownership endpoint
      return this.requestAccessService.transferOwnership([this.currentUser._id], transferEmail);
    };
  }

  onTransferOwnershipConfirmed(transferEmail: string) {
    // Backward compatibility - this should not be called if transferFunction is provided
    if (!this.currentUser?._id) {
      this.toast.error('User ID not found');
      return;
    }

    this.deactivatingAccount = true;

    // Use the new transfer-ownership endpoint
    this.requestAccessService.transferOwnership([this.currentUser._id], transferEmail).subscribe({
      next: (res) => {
        if (res.success) {
          this.toast.success(res.message || 'Ownership transferred successfully');
          this.transferOwnershipDialogVisible = false;
          this.deactivateDialogVisible = false;
          this.deactivateConfirmation = '';
          this.deactivateReason = '';
          this.getProfile();
        } else {
          this.toast.error(res.message || 'Failed to transfer ownership');
        }
        this.deactivatingAccount = false;
      },
      error: (err) => {
        this.toast.error(err?.error?.message || 'Failed to transfer ownership');
        this.deactivatingAccount = false;
      }
    });
  }

  onTransferCompleted(result: { success: boolean; message?: string }) {
    if (result.success) {
      this.toast.success(result.message || 'Ownership transferred successfully');
      this.transferOwnershipDialogVisible = false;
      this.deactivateDialogVisible = false;
      this.deactivateConfirmation = '';
      this.deactivateReason = '';
      this.getProfile();
    } else {
      // Error toast is already shown in the dialog component
    }
  }

  cancelTransferOwnership() {
    this.transferOwnershipDialogVisible = false;
  }


  onMfaToggle(event: boolean) {
    this.mfaEnabled = event
    this.selectedMfaMethod = PRIMARY_AUTH_METHOD.EMAIL_OTP
    const message = event ? 'MFA authentication enabled successfully' : 'MFA authentication disabled successfully';
    this.saveSecurityAndPrivacy(this.selectedMfaMethod, message);
  }

  saveSecurityAndPrivacy(selectedMfaMethod: PRIMARY_AUTH_METHOD = this.selectedMfaMethod, successMessage: string = 'Security and privacy details updated successfully') {
    const userData = new FormData();
    const userDataObj = {
      ...this.profileForm.value,
      mfaEnabled: this.mfaEnabled,
      primaryAuthMethod: selectedMfaMethod,
      mfaSecret: this.currentUser?.mfaSecret,
      passkey: this.currentUser?.passkey,
    };
    userData.append('data', JSON.stringify(userDataObj));
    this.userService.updateProfile(userData).subscribe((res) => {
      if (res.success) {
        if (successMessage) {
          this.toast.success(successMessage);
        }
        this.selectedMfaMethod = res.data.user?.primaryAuthMethod;
        this.currentUser = res.data.user;
      }
    })
  }

  handlePrimaryModeChanges(event: any): void {
    const methodLabel = this.mfaOptions.find(opt => opt.value === event.value)?.label || 'MFA method';
    const message = `Primary MFA method changed to ${methodLabel} successfully`;
    this.saveSecurityAndPrivacy(event.value, message);
  }

  /**
   * Triggers the file input click event to open file picker
   */
  triggerPictureFileInput() {
    this.pictureFileInput.nativeElement.click();
  }

  /**
   * Handles profile picture file selection
   * @param event - File input change event
   */
  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file && this.isValidImageType(file.type)) {
      this.selectedFile = file;
      this.removePicture = false;
      this.profileForm.patchValue({
        profilePicture: URL.createObjectURL(file),
      });
    } else {
      this.toast.error('File not supported');
    }
    input.value = '';
  }

  isValidImageType(type: string): boolean {
    return this.validImageTypes.includes(type);
  }

  /**
   * Removes the selected profile picture
   */
  removeSelectedFile() {
    this.selectedFile = null;
    this.removePicture = true;
    this.profileForm.patchValue({
      profilePicture: this.userAvatarPipe.transform(null)
    });
  }

  cancelChanges() {
    this.getProfile();
    this.canEdit = false;
    this.profileForm.get('selectedMfaMethod')?.disable();
  }

  openChangePassword() {
    this.initializeChangePasswordForm();
    this.changePasswordVisible = true;
  }

  cancelChangePassword() {
    this.initializeChangePasswordForm()
    this.changePasswordVisible = false
  }

  passwordMatchValidator() {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const password = formGroup.get('password')?.value;
      const confirmPassword = formGroup.get('confirmPassword')?.value;
      return password === confirmPassword ? null : { passwordMismatch: true };
    };
  }

  initializeChangePasswordForm() {
    this.changePasswordForm = this.fb.group({
      currentPassword: ['', [Validators.required, Validators.minLength(8)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
    }, { validators: this.passwordMatchValidator() });
  }

  resetChangePassword() {
    this.changePasswordVisible = false
  }

  saveChangePassword() {
    if (!this.changePasswordForm.valid) {
      this.changePasswordForm.markAllAsTouched();
      this.toast.error('Please fill all the required fields');
      return
    }
    const formData = new FormData();
    formData.append('currentPassword', this.changePasswordForm.value.currentPassword);
    formData.append('password', this.changePasswordForm.value.password);
    this.userService.changePassword(formData).subscribe((res) => {
      if (res.success) {
        this.toast.success('Password has been updated successfully');
        this.changePasswordVisible = false;
      }
    })
  }

  onSaveChanges() {
    const userData = new FormData();
    let emailChanged = false;
    const userDataObj = {
      ...this.profileForm.value,
      fullName: this.fullNamePipe.transform({
        firstName: this.profileForm.value.firstName,
        lastName: this.profileForm.value.lastName
      })
    };

    userData.append('data', JSON.stringify(userDataObj));

    if (this.selectedFile) {
      userData.append('profilePicture', this.selectedFile);
    } else if (this.removePicture && this.initialProfilePicture) {
      userData.append('profilePictureUrl', this.initialProfilePicture)
    }
    if (this.currentUser?.email !== this.profileForm.value.email)
      emailChanged = true;
    this.userService.updateProfile(userData).subscribe({
      next: (res) => {
        if (res.success && res.data.user) {
          this.canEdit = false;
          if (emailChanged) {
            this.toast.info('An email has been sent to your updated email address. Kindly confirm it from your inbox');
          }
          this.toast.success('Profile details updated successfully');
          this.getProfile();
        }
      },
      error: (err) => {
        this.toast.error(err.error?.message || 'Failed to update profile', 'Error!');
      }
    });
  }


  goBack() {
    this.router.navigate(['']);
  }


  setupPasskey() {
    if (this.currentUser) {
      this.authService.webAuthnRegisterOptions(this.currentUser.email).subscribe(async (res) => {
        if (res) {
          const attResp = await startRegistration(res.data);
          this.authService.registerPasskey(this.currentUser?.email ?? "", attResp).subscribe((response) => {
            if (response) {
              this.toastService.success('Passkey Registration Successful', 'Success!');
              if (this.currentUser) {
                this.currentUser.passkey = response.data
              }
            } else {
              this.toastService.error('Passkey Registration Failed', 'Error!');
            }
          }
          );
        }
      })

    }
  }

  removePasskey() {
    if (this.currentUser?.passkey !== undefined) {
      this.currentUser.passkey = null;
      if (this.selectedMfaMethod === PRIMARY_AUTH_METHOD.PASSKEYS) {
        this.selectedMfaMethod = PRIMARY_AUTH_METHOD.EMAIL_OTP;
      }
    }
    this.saveSecurityAndPrivacy(this.selectedMfaMethod, 'Passkey removed successfully');
  }


  resetMfaDialog() {
    this.qrCodeDataUrl = '';
    this.mfaCode = '';
    this.qrCodeLoading = false;
    this.verifyingOtp = false;
    this.openMfaDialog = false;
    if (this.currentUser && this.currentUser.mfaSecret) {
      this.currentUser.mfaSecret = "";
      this.removeAuthenticatorMode(false);
    }
  }


  openAuthenticatorMode() {
    this.openMfaDialog = true;
    this.generateQRCode();
  }

  generateQRCode() {
    this.qrCodeLoading = true;
    this.userService.generateMfaQR().subscribe((res) => {
      if (res.success) {
        this.qrCodeDataUrl = res.data.qrCode;
        if (this.currentUser) {
          this.currentUser.mfaSecret = res.data.secret || "";
        }
        this.qrCodeLoading = false;
      }
      else {
        this.toast.error('Failed to generate QR code');
        this.qrCodeLoading = false;
      }
    })
  }

  verifyMFA() {
    if (this.currentUser?.email === undefined) {
      return
    }
    this.authenticationService.verifyMFA(this.currentUser?.email, this.mfaCode).subscribe((response) => {
      if (response) {
        this.toastService.success('MFA Verification Successful', 'Success!');
        // this.selectedMfaMethod = PRIMARY_AUTH_METHOD.MFA
        // this.currentUser?.primaryAuthMethod == PRIMARY_AUTH_METHOD.MFA
        this.IsAuthenticatorModeEnabled = true
        this.openMfaDialog = false
        this.getProfile()
      } else {
        this.removeAuthenticatorMode(false);
        this.toastService.error('MFA Verification Failed', 'Error!');
      }
    });

  }

  removeAuthenticatorMode(showToast: boolean = true) {
    if (this.currentUser != undefined) {
      this.currentUser.mfaSecret = "";
      if (this.selectedMfaMethod === PRIMARY_AUTH_METHOD.MFA) {
        this.selectedMfaMethod = PRIMARY_AUTH_METHOD.EMAIL_OTP;
      }
      this.saveSecurityAndPrivacy(this.selectedMfaMethod, showToast ? 'Authenticator mode removed successfully' : '');
    }
  }
}
